import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { BidClient } from "../core/clients";
import {
    IItaAuctionResult
} from '.';
import { axiosToObservable } from '../core/clients/axiosToObservable';
export class AuctionResultService {
  getAuctionResults = (auctionNames: string[]): Observable<IItaAuctionResult[]> => {
    return axiosToObservable(BidClient.post<IItaAuctionResult[]>('EtrmDissemination/GetAuctionResult', auctionNames)).pipe(
      map((auctionResults: IItaAuctionResult[]) => {
        return auctionResults;
      })
    );
  };  
}